import { render, staticRenderFns } from "./PubMessageList.vue?vue&type=template&id=ec24fd04&scoped=true&"
import script from "./PubMessageList.vue?vue&type=script&lang=ts&"
export * from "./PubMessageList.vue?vue&type=script&lang=ts&"
import style0 from "./PubMessageList.vue?vue&type=style&index=0&id=ec24fd04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24fd04",
  null
  
)

export default component.exports